import React from "react";
import { Text } from "../../atoms/Text/Text";
import styles from "./GameEnd.css";

type GameEndWidegtProps = {
  score: number;
  percentiles?: number[];
};

const AffirmationText = {
  CHAMP: "Fantastic!",
  WINNER: "Impressive!",
  DEFAULT: "Congratulations!",
};

const StarIcon = {
  CHAMP: "/images/star_full.webp",
  WINNER: "/images/star_half_full.webp",
  ACHIEVER: "/images/star_half_empty.webp",
  DEFAULT: "/images/firework.webp",
};

const AchievementText = {
  CHAMP: "Champ",
  WINNER: "Winner",
  ACHIEVER: "Achiever",
};

export class GameEndWidget extends React.Component<GameEndWidegtProps> {
  getAffirmationTitle() {
    return AffirmationText.DEFAULT;
  }

  getAchievementText = () => {
    const { percentiles, score } = this.props;
    const [champScore, winnerScore, achieverScore] = percentiles;

    if (score >= champScore) return AchievementText.CHAMP;
    if (score >= winnerScore) return AchievementText.WINNER;
    if (score >= achieverScore) return AchievementText.ACHIEVER;
  };

  getStarIcon = () => {
    const { percentiles, score } = this.props;
    const [champScore, winnerScore, achieverScore] = percentiles;

    if (score >= champScore) return StarIcon.CHAMP;
    if (score >= winnerScore) return StarIcon.WINNER;
    if (score >= achieverScore) return StarIcon.ACHIEVER;

    return StarIcon.DEFAULT;
  };

  getWidget = () => {
      return (
        <ScoreStar img={this.getStarIcon()} title={this.getAchievementText()} />
      );
  };

  render() {
    return (
      <WidgetContainer>
        {this.props.percentiles.length > 0 && this.getWidget()}
        <Text align="center" bold={true} style={{fontSize: "2rem", fontFamily: "montserrat"}} color="aarp-dark-gray">
          {this.getAffirmationTitle()}
        </Text>
      </WidgetContainer>
    );
  }
}

const WidgetContainer = (props: any) => (
  <div className={styles.gameEndWidgetContainer} {...props} />
);

type ScoreStarProps = {
  img: string;
  title: string;
};

const ScoreStar = ({ title, img }: ScoreStarProps) => (
  <div className={styles.gameEndStar}>
    <Text
      align="center"
      color="main"
      bold={true}
      className={styles.gameEndStarTitle}
    >
      {title}
    </Text>
    <img src={img} alt="score star" className={styles.gameEndScoreStarImg} />
  </div>
);
